const pagePrefix = window.CONFIG.psaPrefix.toUpperCase();

export const pageKey = {
  '/': `${pagePrefix}INDEX`,
  '/home': `${pagePrefix}HOME`,
  '/auth': `${pagePrefix}AUTH`,
  '/receive-code-failed': `${pagePrefix}RECEIVE-CODE-FAILED`,
  '/status/checking': `${pagePrefix}CHECKING`,
  '/status/checking-end': `${pagePrefix}CHECKING-END`,
  '/status/success': `${pagePrefix}SUCCESS`,
  '/status/failed': `${pagePrefix}FAILED`
};

export const pid = `UA-JR-${pagePrefix.substring(0, pagePrefix.length - 1)}`;
